import utils from './utils';

import menu from './components/menu';
import imgtosvg from './components/imgtosvg';
import lazyload from './components/lazy-load';
import fullpage from './components/fullpage';
import registration from './components/registration';
import animations from './components/animations';
import carousels from './components/carousels';
import woocommerce from './components/woocommerce';
//import magicmouse from './components/magicmouse';
import sba from './components/scroll-based-animations';
import accordion from './components/accordion';

function initHiPriorityCommon() {
    imgtosvg.initImgtosvg();
	lazyload.init();
    fullpage.init();
    //magicmouse.initMouse();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
    registration.init();
    menu.initMenu();
    animations.init();
    sba.initScrollBasedAnimations();
    carousels.init();
    woocommerce.init();
    accordion.init();
}

// document.addEventListener( 'DOMContentLoaded', function () {
utils.domReady(function () {
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
